import React from "react";
import "./styles.scss";

import ChevronSmallRight from "../../svgs/ChevronSmallRight";

const HomeBanner = ({
    title = `Whole of market direct lending* investment services`,
    subtitle = `We provide research, capital deployment, risk management and reporting services to institutional investors looking to invest in the European direct lending market.  Discover the best opportunities in direct lending with Orca.`,
    actions = (
        <>
            <a
                className="hero-full__cta no-underline"
                href="https://app.hubspot.com/meetings/iain7"
                title="Schedule a call now"
                target="_blank"
            >
                <button className="btn-simple btn-lg btn-yellow btn-mobile">
                    Schedule a call now{` `}
                    <span className="btn__icon">
                        <ChevronSmallRight />
                    </span>
                </button>
            </a>
            <a
                className="hero-full__cta-secondary"
                href="#learn-more"
                title="Learn more about Orca"
            >
                Learn more
            </a>
        </>
    ),
    risk = `*Direct lending market includes peer to peer lending, marketplace lending and non-bank balance sheet lenders. 
    `
}) => (
    <section className="hero-full">
        <div className="hero-full__wrapper">
            <div className="hero-full__content">
                <h1 className="hero-full__title">{title}</h1>
                <p
                    className="hero-full__subtitle"
                    dangerouslySetInnerHTML={{
                        __html: subtitle
                    }}
                ></p>
                <div className="hero-full__actions">{actions}</div>

                {risk && (
                    <span
                        className="hero-full__risk-statement"
                        dangerouslySetInnerHTML={{
                            __html: risk
                        }}
                    ></span>
                )}
            </div>
        </div>
    </section>
);

export default HomeBanner;
